import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _Config, _IsUserPremiumFromPartners, } from "@discovery/common-dplus/lib/state";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _ShortsVideos } from "./optics";
import { useUser, useAds } from "../../utils/hooks";
const ShortsView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const promotedShortsLengthFromPageResponse = Fold.toArray(_ShortsVideos, data).length;
    return {
        promotedShortsLengthFromPageResponse,
    };
};
const Shorts = ({ promotedShortsLengthFromPageResponse, environment, }) => {
    const [configM] = useGlobalState(_Config);
    const { isAnonymous, userId } = useUser();
    const { adsHasValidPackage, enableAds } = useAds();
    const webAuthUrl = environment.authService.protocol + "://" + environment.authService.domain;
    //Config
    const adsM = M.chain((x) => x.ads, configM);
    const adShortsM = M.chain((x) => x.shorts, adsM);
    const outstreamBannerAdM = M.chain((x) => x.outstreamBannerAd, adShortsM);
    const adUnitPathSuffixM = M.chain((x) => x.adUnitPathSuffix, outstreamBannerAdM);
    const outstreamBannerAdSuffix = M.fromMaybe(adUnitPathSuffixM, "");
    const intervalM = M.chain((x) => x.interval, outstreamBannerAdM);
    const outstreamBannerAdInterval = M.fromMaybe(intervalM, 0);
    const adadUnitPathPrefixM = M.chain((x) => x.adUnitPathPrefix, adsM);
    const adUnitPathPrefix = M.fromMaybe(adadUnitPathPrefixM, "");
    const vastTagM = M.chain((x) => x.vastTag, adsM);
    const shortvastTagM = M.chain((x) => x.shortsVastTag, adsM);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const imaAdsConfig = {
        vastTag: M.fromMaybe(vastTagM, ""),
        shortsVastTag: M.fromMaybe(shortvastTagM, ""),
        enableAds: isPremiumUserFromPartner ? false : enableAds,
    };
    const isAdsEnabled = enableAds && !adsHasValidPackage;
    const shortsCollectionM = M.chain((x) => x.collectionConfiguration, configM);
    const shortsCollectionPromotedM = M.chain((x) => x.shortsPromotedVideos, shortsCollectionM);
    const shortsCollectionAutomatedM = M.chain((x) => x.shortsAllVideos, shortsCollectionM);
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ShortsView, { read: environment, anonymous: isAnonymous, promotedShortsLengthFromPageResponse: promotedShortsLengthFromPageResponse, isAdsEnabled: isAdsEnabled, outstreamBannerAdSuffix: outstreamBannerAdSuffix, outstreamBannerAdInterval: outstreamBannerAdInterval, adPrefix: adUnitPathPrefix, imaAdsConfig: imaAdsConfig, webAuthRedirectionUrl: webAuthUrl, userID: userId, collectionNameForPromotedShorts: M.fromMaybe(shortsCollectionPromotedM, ""), collectionNameForAutomatedShorts: M.fromMaybe(shortsCollectionAutomatedM, "") })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Shorts);

